// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field } from 'redux-form';
import InputField from '../../../customFields/InputField';
import { localCurrencySettings } from '../../../../../../utils/constans';
import SelectField from '../../../customFields/SelectField';
import CheckboxField from '../../../customFields/CheckboxField';

const BasePaySection = ({
  amount,
  quantity,
  basicType,
  requirements,
  enableEmptyValue,
}) => {
  const estimatedPay = ((amount * (basicType === 'Site' ? 1 : quantity)) || 0)
    .toLocaleString('en-US', localCurrencySettings);

  return (
    <div className="group_col">
      <div className="group_name">Base Pay</div>

      <div className="combo_field">
        <div className="small_row">
          <div className="field_name">
            <label htmlFor="amount">Amount*</label>
          </div>
          <div className="field_block">
            <Field
              component={InputField}
              id="amount"
              name="amount"
              type="text"
              maxLength={10}
              placeholder="$0.00"
              required={requirements !== 'disabled'}
            />
          </div>
        </div>
        <div className="check_block">
          <label className="check_btn">
            <Field
              component={CheckboxField}
              type="checkbox"
              name="payBaseRateAsMinimum"
            />
            Pay Base Rate As Minimum
          </label>
        </div>
      </div>

      <div className="combo_field">
        <div className="small_row">
          <div className="field_name">
            <label htmlFor="qty">Qty*</label>
          </div>
          <div className="field_block">
            <Field
              component={InputField}
              id="qty"
              name="quantity"
              type="text"
              maxLength={10}
              placeholder="0"
              required={requirements !== 'disabled'}
            />
          </div>
        </div>
        <div className="check_block">
          <label className="check_btn">
            <Field
              component={CheckboxField}
              type="checkbox"
              name="payOutsideOfApp"
              // disabled
              // format={() => true}
              // normalize={() => true}
            />
            Pay Outside Of App
          </label>
        </div>
      </div>

      <div className="small_row">
        <div className="field_name">
          <label htmlFor="estpay">Est.Pay</label>
        </div>
        <div className="field_block readonly_field">
          <input
            id="estpay"
            type="text"
            value={estimatedPay}
            readOnly
          />
        </div>
      </div>

      <div className="small_row">
        <div className="field_name">
          <label htmlFor="per">Per*</label>
        </div>
        <div className="field_block">
          <Field
            component={SelectField}
            id="per"
            name="basicType"
            enableEmptyValue={enableEmptyValue}
            required={requirements !== 'disabled'}
            options={[
              {
                value: 'Hour',
                label: 'Hour',
              },
              {
                value: 'Device',
                label: 'Device',
              },
              {
                value: 'Site',
                label: 'Site / Flat',
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default BasePaySection;
